<template>
  <div>
    <Skeleton width="40%" height="2rem" class="mb-5"></Skeleton>
    <Skeleton width="100%" height="2rem" class="mb-2"></Skeleton>
    <Skeleton width="100%" height="2rem" class="mb-2"></Skeleton>
    <Skeleton width="100%" height="2rem" class="mb-2"></Skeleton>
    <Skeleton width="100%" height="2rem" class="mb-2"></Skeleton>
  </div>
</template>

<script setup>
import Skeleton from "primevue/skeleton";
</script>
